import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import { Fieldset, FieldsetTitle, RadioButton } from 'components/Form';
import messages from '../../ScheduleForm.messages';

const ScheduleTypeSelector = ({ disabled }) => (
  <Fieldset>
    <Message as={FieldsetTitle} message={messages.classType} />
    <Field name="scheduleType" type="radio" value="recurring" disabled={disabled} component={RadioButton} inline>
      <Message message={messages.recurring} />
    </Field>
    <Field name="scheduleType" type="radio" value="one-time" disabled={disabled} component={RadioButton} inline>
      <Message message={messages.oneTime} />
    </Field>
  </Fieldset>
);

ScheduleTypeSelector.propTypes = {
  disabled: PropTypes.bool,
};

export default ScheduleTypeSelector;
